if (!customElements.get("swiper-carousel")) {
  class SwiperCarousel extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
      this.isInitialized = false;
    }

    connectedCallback() {
      if (this.isInitialized) return;
      setTimeout(() => this.init());
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      if (this.isInitialized) return;
      const {arrowsPlaceholder, ...swiperOptions} = this.readOptionsFromConfig();
      const rootSwiper = this.querySelector(".swiper");

      this.replaceArrows(arrowsPlaceholder);
      this.swiperInstance = new Swiper(rootSwiper, swiperOptions);

      this.isInitialized = true;

      if (this.hasAttribute("data-product-card-media")) {
        this.addEventListener("mouseleave", () => {
          this.swiperInstance.slideTo(1);
        });
      }
      this.dispatchEvent(
        new CustomEvent("swiper:ready", {
          detail: {swiper: this.swiperInstance},
          bubbles: true,
        })
      );
    }

    destroy() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, false);
        this.swiperInstance = null;
      }
      this.isInitialized = false;
    }

    readOptionsFromConfig() {
      const configScript = this.querySelector("script[type='application/json']");
      if (!configScript) {
        console.error("Swiper configuration script not found.");
        return {};
      }

      let config;
      try {
        config = JSON.parse(configScript.textContent);
      } catch (err) {
        console.error("Invalid JSON in swiper configuration script:", err);
        return {};
      }

      const {arrowsPlaceholder, ...swiperConfig} = config;

      return {
        ...swiperConfig,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        },
        arrowsPlaceholder,
      };
    }

    replaceArrows(arrowsPlaceholder) {
      if (!arrowsPlaceholder || !arrowsPlaceholder.selector) return;

      const placeholderElement = document.querySelector(arrowsPlaceholder.selector);
      if (!placeholderElement) {
        console.error(
          `Arrows placeholder element not found for selector: ${arrowsPlaceholder.selector}`
        );
        return;
      }

      const nextArrow = this.querySelector(".swiper-button-next");
      const prevArrow = this.querySelector(".swiper-button-prev");

      if (!nextArrow || !prevArrow) {
        console.error("Swiper navigation arrows not found in the DOM.");
        return;
      }

      const mediaQueryList = arrowsPlaceholder.mediaQuery
        ? window.matchMedia(`(${arrowsPlaceholder.mediaQuery})`)
        : null;

      if (mediaQueryList && !mediaQueryList.matches) return;

      if (arrowsPlaceholder.position === "beforeend") {
        placeholderElement.appendChild(prevArrow);
        placeholderElement.appendChild(nextArrow);
      } else if (arrowsPlaceholder.position === "afterbegin") {
        placeholderElement.insertBefore(nextArrow, placeholderElement.firstChild);
        placeholderElement.insertBefore(prevArrow, placeholderElement.firstChild);
      }
    }
  }

  customElements.define("swiper-carousel", SwiperCarousel);
}
